import type { UnknownAction } from 'redux';

export type HealthCheckAction = FailAction;

export interface FailAction extends UnknownAction {
  payload: {};
  type: 'HEALTH_CHECK:FAIL';
}

export const healthCheckFail = (): FailAction => ({
  payload: {},
  type: 'HEALTH_CHECK:FAIL',
});
